import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import appInfo from "@common/appInfo";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      ...props,
      hasUser: !!appInfo.user
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
